import React from "react";
import Avatar from "@material-ui/core/Avatar";
import Container from "@material-ui/core/Container";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core/styles";

import clsx from 'clsx';
import {Link as RouterLink/*, useParams*/} from "react-router-dom";
import {TwitterTweetEmbed} from 'react-twitter-embed';

import {Brand} from "../Brand";
import {QueueSubscriber, stageClient} from "../logic/StageClient";


const useLocalStyles = makeStyles((theme) => ({
  container: {
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingTop: '3em',
    background: 'white',
  },
  twitterItem: {
    minHeight: '200px', // placeholder for the min vertical space of a tweet - in our typical case.
    marginBottom: '10px',
    padding: 0,
  },
  twitterItemRead: {
    background: 'gray',
  },
  twitterIcon: {
    minWidth: theme.spacing(5),
  },
  twitterNumber: {
    ...Brand.styles.appbar_brand,
    fontSize: '1em',
    width: theme.spacing(4),
    height: theme.spacing(4),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(6),
      height: theme.spacing(6),
      fontSize: '2em',
    },
  },
}));

const queueStateMerge = (newState) => (prevState: QueueStateTypes) => {
  // append the IDs that are now gone to the 'readContents'
  // const prevContents = prevState.contents;
  // if (newState.contents && newState.contents.length) {
  //   const readItems = prevContents.filter(prevId => newState.contents.indexOf(prevId) === -1)
  //   newState.readContents = prevState.readContents.concat(readItems);
  // }
  return Object.assign({}, prevState, newState);
}

interface QueueStateTypes {
  queueId: string | null,
  // readContents: any[],
  contents: any[],
  updatedTs: number,
}

export function ViewTweetQueue() {
  const classes = useLocalStyles();

  // this comes from the route declared with react-router, and it's the most important value
  const queueId = 'twitter-next'; //useParams()['qid'];

  // state
  const [queue, setQueue] = React.useState<QueueStateTypes>({
    queueId: null,
    // readContents: [],
    contents: [],
    updatedTs: 0,
  });

  // pub-sub with stageClient, for this Chat information
  React.useEffect(() => {
    const queueSubscriber: QueueSubscriber = {
      onQueueUpdated(queueId: string, contents: any[], updatedTs: number): void {
        if (!Array.isArray(contents)) return console.log(`Expected the queue contents to be an array.`);
        setQueue(queueStateMerge({
          queueId: queueId,
          contents: contents,
          updatedTs: updatedTs,
        }));
      }
    };
    stageClient.singleSubscribeToQueueAndSwitchToIt(queueId, queueSubscriber);
    return () => stageClient.singleUnsubscribeFromQueue(queueId, queueSubscriber);
  }, [queueId]);

  // check queue type
  if (queueId !== 'twitter-next') return (
    <Container maxWidth="md">
      {`Queue ${queueId} not supported.`}
    </Container>
  );

  // UI rendering types
  const uiItem: { tweetId: string, read: boolean, index: number }[] = [];
  // queue.readContents.forEach(id => uiItem.push({
  //   tweetId: id,
  //   read: true,
  //   index: 0,
  // }));
  queue.contents.forEach((id, index) => uiItem.push({
    tweetId: id,
    read: false,
    index: index + 1,
  }));

  return (<React.Fragment>
    {/* Render Tweets */}
    <Container maxWidth="md" className={classes.container}>
      <Typography variant={"h4"}>Upcoming Tweets</Typography>
      <Typography style={{margin: '1em 0'}}>
        The following are the next 10 tweets to be discussed in the <RouterLink to='/chat/3'>#trending</RouterLink> chat room.
      </Typography>
      {queue.queueId && <List>
        {uiItem.map(item =>
          <ListItem key={item.tweetId} className={clsx(classes.twitterItem, item.read ? classes.twitterItemRead : '')}>
            <ListItemIcon className={classes.twitterIcon}>
              {item.index > 0 && <Avatar className={classes.twitterNumber}>
                {item.index}
              </Avatar>}
            </ListItemIcon>
            <ListItemText>
              <TwitterTweetEmbed tweetId={item.tweetId} options={{
                // options: https://developer.twitter.com/en/docs/twitter-for-websites/embedded-tweets/guides/embedded-tweet-parameter-reference
                width: 520,           // max, experimental
                cards: 'hidden',      // don't load images, videos
                conversation: 'none', // don't load conversation stuff
                align: 'center',      // center
                dnt: true,            // do-not-track to protect our users
              }}/>
            </ListItemText>
          </ListItem>
        )}
      </List>}
      {!queue.queueId && <div>Loading...</div>}
    </Container>
  </React.Fragment>);
}
